import React from "react";
import PropTypes from "prop-types";

import ButtonIcon from "../../components/buttons/buttonIcon";
import * as buttonConstants from "../../components/buttons/buttonConstants";
import TextField from "../../components/inputs/textField";
import SearchableSelectField from "../../components/inputs/searchableSelectField";

const FormEditForm = ({ config }) => {
    return (
        <tr>
            <td>
                <TextField config={{
                    name: "FormName",
                    label: "Form Name",
                    showLabel: false,
                    error: (config.submitted && config.errors.FormName) ? "*" : "",
                    value: config.fields.FormName,
                    maxLength: 50
                }}/>
            </td>
            <td>
                <SearchableSelectField config={{
                    name: "ItemBank",
                    label: "Item Bank",
                    onChange: (event) => config.onItemBankChange(event, config.setField),
                    defaultOption: "Select an item bank",
                    value: config.fields.ItemBankId.toString(),
                    error: (config.submitted && config.errors.ItemBankId) ? "*" : "",
                    showLabel: false,
                    options: config.itemBanks,
                    includeDefaultOption: true
                }}/>
                <input type={"hidden"} value={config.fields.ItemBankId} name={"ItemBankId"}/>
            </td>
            <td className={"text-center"}>
                <ButtonIcon config={{
                    name: "btnSave",
                    label: "Save",
                    iconType: buttonConstants.ICON_SAVE,
                    disabled: config.isLoading,
                    isSubmit: true
                }} />
                <ButtonIcon config={{
                    name: "btnCancel",
                    label: "Cancel",
                    onClick: config.onEditFormCancel,
                    iconType: buttonConstants.ICON_CANCEL,
                    disabled: config.isLoading
                }} />
                <input type={"hidden"} name={"Id"} value={config.fields.Id} />
            </td>
        </tr>
    );
};

FormEditForm.propTypes = {
    config: PropTypes.shape({
        form: PropTypes.object.isRequired,
        fields: PropTypes.object.isRequired,
        submitted: PropTypes.bool.isRequired,
        errors: PropTypes.object.isRequired,
        isLoading: PropTypes.bool,
        onItemBankChange: PropTypes.func.isRequired,
        onEditFormCancel: PropTypes.func.isRequired,
        itemBanks: PropTypes.array.isRequired,
        setField: PropTypes.func.isRequired
    })
};

export default FormEditForm;